import { gql } from '@apollo/client'

export const GET_ENROLLMENT = gql`
  query getEnrollment(
    $id: ID!
    $ordenation: OrdenationInputObject!
    $courseId: ID!
    $pagination: PaginationInputObject!
  ) {
    enrollment(id: $id) {
      id
      lessonsCompletedPerModule
      activatedAt
      availableUntil
      unlimited
      certificates(courseId: $courseId) {
        fileUrl
      }
      courseClassRelease(courseId: $courseId) {
        enabled
        startAt
        defaultOffset
      }
      schoolProduct {
        id
        certification
        certificationMinProgress
        availableTimeLength
        expireDate
        courses {
          id
          kind
          linearRequirements
        }
      }
      progressCard(courseId: $courseId) {
        id
        progress
        total
        completed
        lessonsProgresses(ordenation: $ordenation, pagination: $pagination) {
          id
          completed
          progress
          lastViewAt
          lessonId
          currentVideoTime
        }
      }
    }
  }
`
export const GET_ENROLLMENT_IDS_INFO = gql`
  query getEnrollmentIdsInfo($id: ID!) {
    enrollment(id: $id) {
      id
      schoolProduct {
        id
        courses {
          id
          kind
          courseModules(pagination: { offset: 0, limit: 1 }) {
            nodes {
              id
              courseContents(pagination: { offset: 0, limit: 1 }) {
                nodes {
                  id
                }
              }
            }
          }
        }
        path {
          id
        }
      }
    }
  }
`
